import * as React from "react";
import { forwardRef } from "react";
const AmexIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 49 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40 8H8v32h32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006FCF",
  d: "M8 8v32h32v-5.056h-4.416l-1.632-1.9091-1.696 1.9091H19.712V24.7789h-4.1389l5.1738-11.712h5.0342l1.216 2.656v-2.656h6.2509l1.0451 2.784 1.024-2.784H40V8zm28.384 6.72-1.6429 4.3309-.4371 1.1737-.448-1.1737-1.6531-4.3309h-3.616v8.5338h2.176v-5.5572l-.0109-1.1206.4269 1.1206 2.08 5.5572h2.0691l2.0909-5.5572.4051-1.1097v6.6669H40V14.72zm-14.464 0-3.776 8.5338h2.4742l.6618-1.6429h4.1389l.6611 1.6429h2.5069L24.832 14.72zm1.0022 2.8909.4269-1.0663.4269 1.0663.8851 2.1542h-2.624zm13.6327 7.1789L33.984 27.552l-2.56-2.7622h-9.9629v8.5011h7.1258v-1.8451h-4.9498v-1.4829h4.8538v-1.8343h-4.8538v-1.4937h4.9498v-1.8451l3.9782 4.2662-3.9782 4.2349h2.752l2.592-2.7731 2.5811 2.7731h2.8262l-3.9891-4.2669 3.9891-4.2342zm1.0342 4.224L40 31.4669V26.592z"
}));
const ForwardRef = forwardRef(AmexIcon);
export { ForwardRef as AmexIcon };